import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseRestApiService } from 'src/app/service/baseRestApiService.service';
import { UrlProviderService, EndPoints } from 'src/app/service/urlprovider.service';

@Injectable({
    providedIn: 'root'
})
export class InaSchoolEnrollmentsService extends BaseRestApiService {
    constructor(http: HttpClient, urlProvider: UrlProviderService) {
        super(http, urlProvider);
    }

    getINASchoolEnrollments(urlParam: string): Observable<any> {
		return this.get<any>(EndPoints.get_INA, undefined, urlParam);
	}

    deleteINA(requrestPayload: any):Observable<any> {
        return this.delete<any>(EndPoints.delete_INA, false, requrestPayload, '');
    }



}
